import React from 'react'
import classnames from 'classnames/bind'

import { Text } from 'components/typo'
import Image from 'components/shared/Image'
import SocialLink from 'components/shared/SocialLink'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function AuthorContent({
  avatar,
  description,
  username,
  github,
  twitter,
  linkedin,
  Instagram,
  Email,
  Discord,
}) {
  return (
    <div className={cx(css.AuthorContent)}>
      {avatar && (
        <Image
          format="thumbnail"
          className={css.image}
          fluid
          {...avatar}
          alt=""
        />
      )}

      {username && <Text className={css.authorName}>{username}</Text>}

      <ul className={css.socialList}>
        <SocialLink link={github} />
        <SocialLink link={twitter} />
        <SocialLink link={linkedin} />
        <SocialLink link={Instagram} />
        <SocialLink link={Email} />
        <SocialLink link={Discord} />
      </ul>

      {description && <Text className={css.description}>{description}</Text>}
    </div>
  )
}
